var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgClearSmall = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  fill: "#1B1F23",
  "aria-hidden": "true",
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m16 14.586-2.293-2.293a1 1 0 0 0-1.414 1.414L14.586 16l-2.293 2.293a1 1 0 0 0 1.414 1.414L16 17.414l2.293 2.293a1 1 0 0 0 1.414-1.414L17.414 16l2.293-2.293a1 1 0 0 0-1.414-1.414zM16 24a8 8 0 1 1 0-16 8 8 0 0 1 0 16"
})));
export default SvgClearSmall;